<template>
  <div v-show="visible" class="card h-100 wallet-summary-card">    
    <div class="row">
      <div class="container">
        <div class="col-sm-12 exchange-card-header">
          <img
            v-if="'bfb' === exchange.logo"
            class="exchange-logo"
            src="@/assets/images/XBUL.svg"
            :alt="exchangeTitle"
          >
          <img v-else
            class="exchange-logo"
            src="@/assets/images/Deutsche-Boerse_Logo.svg"
            :alt="exchangeTitle"
          >
          <p class="exchange-card-title">{{ exchangeTitle }}</p>
        </div>
      </div>
    </div>
    <div class="card-body summary-card-body">
      <table class="table positions-summary-table">
        <tbody>
          <tr>
            <td v-if="1200 > windowsWidth" :class="smallTextClass">{{ t("balanceLabel") }}</td>
            <td v-else>{{ t("balanceLabel") }}</td>
            <td v-if="'EUR' === currency" class="equity_align_right_heavy" :class="smallTextClass">
              {{ formatPrice(exchange.valueInEur, "EUR", 2).replace(" ", "&nbsp;") }}
            </td>
            <td v-if="'BGN' === currency" class="equity_align_right_heavy" :class="smallTextClass">
              {{ formatPrice(exchange.valueInBgn, "BGN", 2).replace(" ", "&nbsp;") }}
            </td>
          </tr>
          <tr>
            <td :class="smallTextClass">{{ t("instrumentsLabel") }}</td>
            <td class="equity_align_right_heavy" :class="smallTextClass">
              {{ parseNumber(exchange.positionsCount, 0) }}
            </td>
          </tr>
          <tr v-if="0 < parseFloat(exchangeBaseValue)">
            <td :class="smallTextClass">{{ t("returnLabel") }}</td>
            <td
              v-if="'EUR' === currency && exchangeBaseValue - exchangeBaseAvgValue > 0"
              class="greenColor equity_align_right_heavy return-value-cell"
              :class="smallTextClass"
            >
              <span class="return-value-with-icon">
                <span class="return-value-text">+{{ parseNumber(exchange.valueInEur - exchange.avgValueInEur) }} (+{{ parseNumber(exchangeReturnPercent) }}%)</span>
                <img class="quote-change-icon" :src="quoteUpIcon" alt="">
              </span>
            </td>
            <td
              v-else-if="'EUR' === currency && exchangeBaseValue - exchangeBaseAvgValue < 0"
              class="redColor equity_align_right_heavy return-value-cell"
              :class="smallTextClass"
            >
              <span class="return-value-with-icon">
                <span class="return-value-text">{{ parseNumber(exchange.valueInEur - exchange.avgValueInEur) }} ({{ parseNumber(exchangeReturnPercent) }}%)</span>
                <img class="quote-change-icon" :src="quoteDownIcon" alt="">
              </span>
            </td>
            <td
              v-else-if="'BGN' === currency && exchangeBaseValue - exchangeBaseAvgValue > 0"
              class="greenColor equity_align_right_heavy return-value-cell"
              :class="smallTextClass"
            >
              <span class="return-value-with-icon">
                <span class="return-value-text">+{{ parseNumber(exchange.valueInBgn - exchange.avgValueInBgn) }} (+{{ parseNumber(exchangeReturnPercent) }}%)</span>
                <img class="quote-change-icon" :src="quoteUpIcon" alt="">
              </span>
            </td>
            <td
              v-else-if="'BGN' === currency && exchangeBaseValue - exchangeBaseAvgValue < 0"
              class="redColor equity_align_right_heavy return-value-cell"
              :class="smallTextClass"
            >
              <span class="return-value-with-icon">
                <span class="return-value-text">{{ parseNumber(exchange.valueInBgn - exchange.avgValueInBgn) }} ({{ parseNumber(exchangeReturnPercent) }}%)</span>
                <img class="quote-change-icon" :src="quoteDownIcon" alt="">
              </span>
            </td>
            <td v-else-if="showNeutralReturn" class="redColor equity_align_right_heavy return-value-cell" :class="smallTextClass">
              {{ parseNumber(0) }}
              ({{ parseNumber(0) }}%)
            </td>
          </tr>
          <tr v-else>
            <td :class="smallTextClass">{{ t("returnLabel") }}</td>
            <td class="equity_align_right_heavy return-value-cell" :class="smallTextClass">
              {{ parseNumber(exchangeBaseValue - exchangeBaseAvgValue) }} ({{ parseNumber(0) }}%)
            </td>
          </tr>
          <tr v-if="!isNaN(equitiesSharesCount)">
            <td :class="smallTextClass">{{ t("positionsPercentageLabel") }}</td>
            <td v-if="0 !== allEquitiesValueInCurrentCurrency" class="equity_align_right_heavy" :class="smallTextClass">
              <span class="progress-meter-value">
                <meter
                  :value="clampPercent(exchange.valueInCurrentCurrency / allEquitiesValueInCurrentCurrency * 100)"
                  min="0"
                  max="100"
                ></meter>
                <span class="progress-percent">{{
                  parseNumber(clampPercent(exchange.valueInCurrentCurrency / allEquitiesValueInCurrentCurrency * 100))
                }}%</span>
              </span>
            </td>
            <td v-else></td>
          </tr>
          <tr v-else>
            <td colspan="2" :class="smallTextClass">
              <meter value="0" min="0" max="100"></meter>&nbsp;0%
            </td>
          </tr>
          <tr v-if="!isNaN(equitiesSharesCount)">
            <td :class="smallTextClass">{{ t("balancePercentageLabel") }}</td>
            <td v-if="0 !== totalBalance" class="equity_align_right_heavy" :class="smallTextClass">
              <span class="progress-meter-value">
                <meter
                  :value="clampPercent(exchange.valueInCurrentCurrency / totalBalance * 100)"
                  min="0"
                  max="100"
                ></meter>
                <span class="progress-percent">{{
                  parseNumber(clampPercent(exchange.valueInCurrentCurrency / totalBalance * 100))
                }}%</span>
              </span>
            </td>
            <td v-else></td>
          </tr>
          <tr v-else>
            <td colspan="2" :class="smallTextClass">
              <meter value="0" min="0" max="100"></meter>&nbsp;0%
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <button
      v-if="showDetailsButton"
      type="button"
      class="btn btn-primary w-90 m-2"
      :class="smallTextClass"
      @click.prevent="openBreakdown(exchange.id)"
    >
      {{ t("viewInstrumentsLabel") }}
    </button>
  </div>
</template>

<script>
import { getExchangeDisplayName } from "@/assets/js/exchange_labels.js";
import quoteDownIcon from "@/assets/images/Quote-Down.svg";
import quoteUpIcon from "@/assets/images/Quote-Up.svg";

export default {
  name: "WalletExchangeSummaryCard",
  props: {
    exchange: {
      type: Object,
      required: true
    },
    visible: {
      type: Boolean,
      required: true
    },
    currency: {
      type: String,
      required: true
    },
    windowsWidth: {
      type: Number,
      required: true
    },
    allEquitiesValueInCurrentCurrency: {
      type: [Number, String],
      required: true
    },
    totalBalance: {
      type: [Number, String],
      required: true
    },
    equitiesSharesCount: {
      type: [Number, String],
      required: true
    },
    translator: {
      type: Function,
      required: true
    },
    priceFormatter: {
      type: Function,
      required: true
    },
    numberParser: {
      type: Function,
      required: true
    },
    openBreakdown: {
      type: Function,
      required: true
    },
    showDetailsButton: {
      type: Boolean,
      default: true
    },
    showNeutralReturn: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      quoteDownIcon,
      quoteUpIcon
    };
  },
  computed: {
    exchangeBaseCurrency() {
      return this.exchange.baseCurrency || "EUR";
    },
    exchangeBaseValue() {
      return "BGN" === this.exchangeBaseCurrency ? this.exchange.valueInBgn : this.exchange.valueInEur;
    },
    exchangeBaseAvgValue() {
      return "BGN" === this.exchangeBaseCurrency ? this.exchange.avgValueInBgn : this.exchange.avgValueInEur;
    },
    exchangeReturnPercent() {
      return ((this.exchangeBaseValue - this.exchangeBaseAvgValue) / this.exchangeBaseAvgValue) * 100;
    },
    exchangeTitle() {
      return getExchangeDisplayName(this.exchange, this.$store.getters["getUserLanguage"]);
    },
    smallTextClass() {
      return { "xsmall-font-size": 1200 > this.windowsWidth };
    }
  },
  methods: {
    t(key, ...args) {
      return this.translator(key, ...args);
    },
    formatPrice(...args) {
      return this.priceFormatter(...args);
    },
    parseNumber(...args) {
      return this.numberParser(...args);
    },
    clampPercent(value) {
      const percent = parseFloat(value);
      return Number.isFinite(percent) ? Math.min(Math.max(percent, 0), 100) : 0;
    }
  }
};
</script>

<style scoped>
.xsmall-font-size {
  font-size: x-small;
}

.greenColor {
  color: #189e18;
}

.redColor {
  color: #ff0000;
}

.equity_align_right_heavy {
  font-weight: bold;
  text-align: right;
}

.positions-summary-table td {
  font-size: 1rem;
  line-height: 1.35;
  padding: 0.45rem 0.5rem;
}

.positions-summary-table td:first-child {
  white-space: nowrap;
}

.positions-summary-table td.return-value-cell {
  line-height: 1;
  white-space: nowrap;
}

.positions-summary-table {
  margin-bottom: 0;
}

.progress-meter-value {
  align-items: center;
  display: inline-flex;
  gap: 0.25rem;
  white-space: nowrap;
}

.progress-percent {
  display: inline-block;
  min-width: 3.75rem;
  text-align: right;
}

.exchange-logo {
  flex: 0 0 56px;
  height: 56px;
  object-fit: contain;
  width: 56px;
}

.exchange-card-header {
  align-items: center;
  border-bottom: 1px solid #dee2e6;
  display: flex;
  gap: 1rem;
  height: 3.25rem;
  justify-content: center;
  min-height: 3.25rem;
  padding: 0 1rem;
}

.exchange-card-title {
  font-size: 1.25rem;
  font-weight: bold;
  line-height: 1.25;
  margin: 0;
  text-align: center;
}

.summary-card-body {
  padding: 0.5rem 1rem 0.25rem;
}

.wallet-summary-card .btn {
  display: block;
  margin: 0.5rem 1rem 0.75rem !important;
  padding: 12px 60px;
  width: calc(100% - 2rem);
}

.quote-change-icon {
  display: block;
  flex: 0 0 12px;
  height: 12px;
  margin: 0;
  align-self: center;
  width: 12px;
}

.return-value-with-icon {
  align-items: center;
  display: flex;
  gap: 0.15rem;
  justify-content: flex-end;
  line-height: 1;
  min-height: 1.2rem;
  width: 100%;
}

.return-value-text {
  transform: translateY(1px);
}
</style>
